import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { getPlatform } from '../../../store/selectors';
import { Platform } from '../../../store/typings';
import AiAssistantProductCard from '../../ProductCard/AiAssistantProductCard';
import Slideshow from '../../Slideshow/Slideshow';
import { AiAssistantRecommendedProductsMessage } from '../types';
import getRecommendedVariantsList from './getRecommendedVariantsList';

type AiAssistantRecommendedProductsProps = {
    messageId: AiAssistantRecommendedProductsMessage['id'];
    products: AiAssistantRecommendedProductsMessage['products'];
};

const AiAssistantRecommendedProducts = ({
    messageId,
    products,
}: AiAssistantRecommendedProductsProps): ReactElement => {
    const platform = useSelector(getPlatform);
    const isAddToCartEnabled = platform === Platform.SHOPIFY;
    const recommendedVariants = getRecommendedVariantsList(products);
    const allItemsLackImages = recommendedVariants.every((variant) => !variant.image_url);

    return (
        <Slideshow
            items={recommendedVariants}
            itemKey="variant_id"
            isWithoutImages={allItemsLackImages}
            renderItem={(item): ReactElement => (
                <AiAssistantProductCard
                    key={item.variant_id}
                    variant={item}
                    product={item.product}
                    messageId={messageId}
                    isAddToCartEnabled={isAddToCartEnabled}
                />
            )}
        />
    );
};

export default AiAssistantRecommendedProducts;
